/*
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/

/*
import React from 'react';
import ReactDOM from 'react-dom';
import LoginRegister from './LoginRegister';

ReactDOM.render(
  <React.StrictMode>
    <LoginRegister />
  </React.StrictMode>,
  document.getElementById('root')
);
*/
/*
import React from 'react';
import ReactDOM from 'react-dom';
import LoginRegister from './components/LoginRegister/login_register';

ReactDOM.render(
  <React.StrictMode>
    <LoginRegister />
  </React.StrictMode>,
  document.getElementById('root')
);
*/
/* CURRENTLY USING
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
*/

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// render the App component into the root DOM node inside public/index.html
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
